import React, { useState, useEffect } from 'react';
import { Result, Typography } from 'antd';
import { contactUsLink } from '../utils/utils.js';
import { t } from 'i18next';

const ErrorMsg = ({ errorDetails }) => {
    const { Text } = Typography;

    const [errMsg, setErrMsg] = useState(t('errMsg1'));

    const errorType = errorDetails?.errorType;



    useEffect(() => {
        if (errorType === "500") {
            setErrMsg(t('errMsg1'));
        }
        else {
            const errorType = errorDetails?.errorName || "NO_VALUE";

            switch (errorType) {
                case "ERR1": setErrMsg(t('errMsg1'));
                    break;

                case "ERR2": setErrMsg(t('errMsg2'))
                    break;

                case "ERR3": setErrMsg(t('errMsg3'));
                    break;

                default: setErrMsg(t('errMsg1'));
            }
        }
    }, []);


    return (
        <div>
            <Result
                status={errorType}
                subTitle={
                    <Text strong className="err-txt">
                        {errMsg}
                        <a
                            href={contactUsLink}
                            target="_blank"
                        >
                            {t('contactUs')}
                        </a>
                        {t('errMsgContactUsPostFix')}
                    </Text>
                }
            />
        </div>
    )
}

export default ErrorMsg;